import React from "react";

import { t } from "app/utils";

import QueryStringSwitch, { QueryStringSwitchState } from "components/filters/QueryStringSwitch";

const queryKey = "f";
const options = {
  automatic: t("From CultureBot"),
  manual: t("From colleagues")
};

const FromFilter = () => (
  <QueryStringSwitch
    clearLabel={t("All recognizers")}
    options={options}
    queryKey={queryKey}
    title={t("From")}
  />
);

export const FromFilterState = () => (
  <QueryStringSwitchState options={options} queryKey={queryKey} />
);

export default FromFilter;
